import { render, staticRenderFns } from "./ChooseCar.vue?vue&type=template&id=57a53d8b&scoped=true"
import script from "./ChooseCar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseCar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChooseCar.vue?vue&type=style&index=0&id=57a53d8b&prod&lang=scss&scoped=true"
import style1 from "./ChooseCar.vue?vue&type=style&index=1&id=57a53d8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a53d8b",
  null
  
)

export default component.exports